import { FC } from "react";

import Box from "@mui/material/Box";

import PhysicalRedeem from "sections/itemsPage/PhysicalRedeem";
import PhysicalRedeemedInfo from "sections/itemsPage/PhysicalRedeemedInfo";

import Loader from "components/Loader";

import { RedeemProposalStatus } from "services/redeem/RedeemProposalResult";

interface SectionClaimingPhysicalProps {
  isOwner: boolean;
  contractAddress: string;
  tokenId: number;
  redeemLimitDate?: Date | number | null;
  hash: string;
  redeemInfo: RedeemProposalStatus[] | null;
  isPhysicalRedeemed: boolean;
  isRedeemProposesLoading: boolean;
}

const SectionClaimingPhysical: FC<SectionClaimingPhysicalProps> = ({
  isOwner,
  contractAddress,
  tokenId,
  redeemLimitDate,
  hash,
  redeemInfo,
  isPhysicalRedeemed,
  isRedeemProposesLoading,
}) => {
  if (isRedeemProposesLoading) {
    return (
      <Box my={2}>
        <Loader />
      </Box>
    );
  }

  return (
    <>
      {isPhysicalRedeemed ? (
        <Box mb={4}>
          <PhysicalRedeemedInfo redeemHash={hash} />
        </Box>
      ) : (
        <PhysicalRedeem
          isOwner={isOwner}
          contractAddress={contractAddress}
          tokenId={tokenId}
          redeemLimitDate={redeemLimitDate}
          redeemInfo={redeemInfo}
        />
      )}
    </>
  );
};

export default SectionClaimingPhysical;
